import { Grid } from "@mui/material";
import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { SIZES } from "theme";

const Companies = ({ companies, small }) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
      padding={small ? 0 : "0 80px"}
      marginBottom={small ? "40px" : "80px"}
      flexDirection={small ? "column" : "row"}
    >
      <Grid container spacing={2}>
        {companies.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box display="flex" flexDirection="column" alignItems="center">
                <img
                  src={item?.attributes?.investor_logo?.data?.attributes?.url}
                  alt={
                    item.item?.attributes?.investor_logo?.data?.attributes
                      ?.caption
                  }
                />
                <Text
                  fontSize={small ? SIZES.sizteen : "20px"}
                  fontWeight="bold"
                  textColor="white"
                >
                  {item.attributes?.investor_name}
                </Text>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Companies;
